import { Suspense, useState } from 'react';

import { CloseIcon } from '@braskai/icons';
import { useDeviceType } from '@braskai/ui-kit';
import { Outlet } from 'react-router-dom';

import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';
import { Stack } from '@mui/material';

import { useLandingFlow } from '@/features/landingFlow';
import { CreateTeamspaceModal } from '@/features/teamspace';

import { ServerNotificationBanner, useSettingsQuery } from '@/entities/user/currentUser';

import { useInterfaceLanguage } from '@/shared/i18n';
import { Loader } from '@/shared/ui/Loader';
// eslint-disable-next-line boundaries/element-types
import { DesktopSidebar } from '../../../sidebar';
import { SContainer, SDesktopHint, SDesktopHintClose } from './styled';

const DESKTOP_HINT_DISMISSED_KEY = 'desktopHintDismissed';

export const MainLayout = () => {
  const { t } = useInterfaceLanguage();
  const { isMobile } = useDeviceType();
  const [isDesktopHintDismissed, setIsDesktopHintDismissed] = useState(
    () => sessionStorage.getItem(DESKTOP_HINT_DISMISSED_KEY) === 'true',
  );
  const { isLandingFlow } = useLandingFlow();
  const { isPending: areSettingsPending } = useSettingsQuery();

  // A reload on /pricing has no cached workspace settings. Wait before library
  // pages interpret default feature flags as denied access and redirect home.
  if (isLandingFlow || areSettingsPending) return <Loader />;

  return (
    <SContainer>
      <DesktopSidebar />
      <Stack flex="1" position="relative">
        <ServerNotificationBanner />
        {isMobile && !isDesktopHintDismissed && (
          <SDesktopHint>
            <DesktopWindowsRoundedIcon fontSize="small" aria-hidden />
            {t('editor.mobile.fullExperience')}
            <SDesktopHintClose
              aria-label={t('common.close')}
              data-testid="desktop-hint-close"
              type="button"
              onClick={() => {
                sessionStorage.setItem(DESKTOP_HINT_DISMISSED_KEY, 'true');
                setIsDesktopHintDismissed(true);
              }}
            >
              <CloseIcon color="#FFFFFF80" height={16} width={16} />
            </SDesktopHintClose>
          </SDesktopHint>
        )}
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </Stack>
      {/* The sidebar's New Teamspace opens it from every page of the space. */}
      <CreateTeamspaceModal />
    </SContainer>
  );
};
